var getType = function getType(extensionFor) {
  if (extensionFor === 'EmailEditor' || extensionFor === 'EmailPreview') return 'File';
  if (extensionFor === 'JourneyPreview' || extensionFor === 'JourneyEditor') return 'Journey';
  if (extensionFor === 'ContactListPreview' || extensionFor === 'ContactListEditor') return 'ContactList';
  if (extensionFor === 'ContactPreview' || extensionFor === 'ContactEditor') return 'Contact';
  throw new Error('Unknown AI Extension for ' + extensionFor);
};

var getId = function getId(workspace, path, id) {
  if (id) return id;

  if (workspace && path) {
    if (path.indexOf('.') > -1) if (!path.endsWith('/')) path = path + '/';
    return workspace + '/' + path;
  }

  throw new Error('Unknown AI Identifier ' + workspace + ' ' + path + ' ' + id);
};

var getProps = function getProps(extensionFor, workspace, path, id) {
  return {
    type: getType(extensionFor),
    id: getId(workspace, path, id)
  };
};

export default {
  getProps: getProps
};